import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { AuthProvider } from "./contexts/AuthContext";
import DashboardPage from "./pages/Dashboard";
import HomePage from "./pages/Home";
import SentimentPage from "./pages/Sentiment";
import PolicyPage from "./pages/Policy";
import SearchPage from "./pages/Search";
import DetailPage from "./pages/Detail";
import StatsPage from "./pages/Stats";
import IndustryPage from "./pages/Industry";
import TimelinePage from "./pages/Timeline";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/news" element={<HomePage />} />
            <Route path="/sentiment" element={<SentimentPage />} />
            <Route path="/policy" element={<PolicyPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/article/:id" element={<DetailPage />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/industry" element={<IndustryPage />} />
            <Route path="/timeline" element={<TimelinePage />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}
